import { Chip } from './Chip';
import { IComponentDefinition } from '../../../grapesJs/reactComponentsRegistry/types';
import { COMMON_COMPONENT_PROPS } from '../../../grapesJs/reactComponentsRegistry/const';

export const chipComponent: IComponentDefinition = {
  ...COMMON_COMPONENT_PROPS,
  id: 'chip',
  component: Chip,
  tagName: 'chip',
  stylable: false,
  droppable: false,
  defaultAttributes: {
    children: 'Москва',
    theme: 'default',
  },
  traits: [
    {
      type: 'text',
      name: 'children',
      label: 'Текст',
    },
    {
      type: 'select',
      label: 'Тема',
      name: 'theme',
      default: 'default',
      options: [
        { id: 'default', value: 'default', name: 'По умолчанию' },
        { id: 'green', value: 'green', name: 'Зеленая' },
      ],
    },
  ],
  block: {
    label: 'Chip',
    category: 'Cities',
    content: '<Chip>Москва</Chip>',
  },
};
